module.exports = __webpack_public_path__ + "static/media/sound.ead1150a.mp3";